import script from "./CompanyProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProfileView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProfileView.vue?vue&type=style&index=0&id=5547ea93&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5547ea93"]])

export default __exports__